import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCarrierResults from './ReportCarrierResults'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportCarrierResults} />
    </Switch>
)

export default Components
